export default "__VITE_ASSET__BCCjUfe7__"